import React from 'react'
import './Home.css'
import { Link } from 'react-router-dom'
function Home() {
  return (
    <>
      {/* Page 1 => Introduction  */}
      <section className="sec-home-1">
        <div className="container">
          <div className="home-top">
            <img src="/img/side-logo.png" alt="Side Logo" className="side-logo" />

            <div className="center-text">
              <h2>AAH INTERNATIONAL</h2>
              <p className='lead'><b>Import & Export Company</b></p>
              <p className='lead'><b>Fresh Organic, Vegetables, Fruits, Meats & All Grocery Items</b></p>
            </div>

            <img src="/img/logo.png" alt="Company Logo" className="company-logo" />
          </div>

          <div className="home-bottom">
            <img src="/img/mix-fruits2.png" alt="Rise Bag" className="bag rise-bag" />
            <img src="/img/flags1.png" alt="Flags" className="flags" />
            <img src="/img/mix-vegetables.png" alt="Pulses Bag" className="bag pulses-bag" />
          </div>

        </div>
      </section>

      {/* Page 2 => Frozen Mix Vegitables */}
      <section className='frozen-food-sec'>
        <div className='container'>
          <h2>PREMIUM EXPORT QUALITY FROZEN MIX VEGETABLE</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-2 order-md-1">
              <div className="frozen-text-box p-4 ">
                <p className='lead'>
                  Frozen vegetables are a quick, healthy, and convenient cooking option. Harvested at peak ripeness and flash-frozen to lock in nutrients, they include peas, carrots, corn, broccoli, and more. Perfect for steaming, microwaving, or adding to soups and meals.
                </p>
              </div>
              <div className="img-box2 order-2">
                <img src="/img/frozenfood2.jpg" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1">
                <img src="/img/frozenfood1.jpg" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>

          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>

        </div>
      </section>
      {/* Page 3 => Frozen French Fries */}
      <section className='frozen-food-sec'>
        <div className='container'>
          <h2>PREMIUM EXPORT QUALITY FROZEN FRENCH FRIES</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-2 order-md-1">
              <div className="frozen-text-box p-4 ">
                <p className='lead'>
                  Frozen French fries are a convenient, ready-to-eat snack made from high-quality Lady Rosetta potatoes. Pre-cut and pre-cooked, they’re popular worldwide in homes and restaurants. Our crispy 9mm fries deliver perfect taste just follow the cooking for best results!
                </p>
              </div>
              <div className="img-box2 order-2">
                <img src="/img/fries2.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1">
                <img src="/img/fries1.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 4 => mangoes */}
      <section className='mango-layout'>
        <div className='container1'>
          <h2 className='h2-mangeo-sec'>PREMIUM EXPORT QUALITY MANGEOS</h2>
          <div className='row mango-main'>

            <div className='col-md-6 col-sm-12 left-column'>
              <div className='top-row d-flex'>
                <div className='half-img'>
                  <img src='/img/mango1.png' alt='Mango 1' />
                </div>
                <div className='half-img'>
                  <img src='/img/mango2.png' alt='Mango 2' />
                </div>
              </div>
              <div className='bottom-row'>
                <img src='/img/mango3.png' alt='Mango 3' />
              </div>
            </div>

            <div className='col-md-6 col-sm-12 right-column d-flex flex-column'>
              <div className='top-full-img'>
                <img src='/img/freshmango.png' alt='Fresh Mango' />
              </div>
            </div>
          </div>

          <div className='text-block'>
            <p className='lead'>AHH INTERNATIONAL IMPORT & EXPORT GROUP is a leading exporter of premium fresh mangoes from Pakistan. Our certified farms, spanning 70 acres in Tando Ghulam Ali, Multan, and Sindh, produce top-quality varieties like Sindhri, Chaunsa, and Dussehri. We proudly serve both national and international markets with the highest standards in mango farming and export.
            </p>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>

      </section>

      {/* Page 5 => POTATOES */}
      <section className='frozen-food-sec'>
        <div className='container'>
          <h2 className='potatos'>PREMIUM EXPORT QUALITY POTATOES</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-2 order-md-1">
              <div className="img-box2 order-md-1">
                <img src="/img/potato1.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
              <div className="frozen-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1.12rem' }}>Potatoes are mainly grown in Punjab, Pakistan. They are ideal for chips, snacks, French fries, and potato flour due to their high dry matter. With red skin and a round shape, they store well and are also great for starch and mashed use. Potatoes with skin are a good source of potassium and vitamin C and nutritious.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1 order-md-3">
                <img src="/img/potato2.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 6 => MANDARIN */}
      <section className='fries-section'>
        <div className='container1'>
          <h2>PREMIUM EXPORT QUALITY MANDARIN</h2>

          <div className="fries-row row">

            <div className="col-md-6 col-sm-12 fries-left-col d-flex flex-column order-2 order-md-1">
              <div className="fries-single-img-box order-md-1">
                <img src="/img/mango-1.png" alt="Frozen Pack" className="fries-single-img w-100" />
              </div>
              <div className="fries-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1.12rem' }}>
                  Mandarin oranges, grown in Pakistan, are sweet, juicy, and packed with health benefits. They have only around 60 calories and contain no fat, cholesterol, or sodium. Rich in Vitamin C, mandarins are increasingly produced. At AHH INTERNATIONAL IMPORT & EXPORT GROUP, we grow fresh mandarins on our own farms and export them to the Middle East and beyond.
                </p>
              </div>
            </div>


            <div className="col-md-6 col-sm-12 fries-right-col order-1 order-md-2">
              <div className="fries-grid d-flex flex-wrap gap-2">
                <div className="fries-grid-img-box w-50">
                  <img src="/img/mango-2.png" alt="Potato A" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/mango-3.png" alt="Potato B" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/mango-4.png" alt="Potato C" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/mango-5.png" alt="Potato D" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
     
      {/* Page 8 =>  bananna */}
      <section className='mango-layout'>
        <div className='container1'>
          <h2 className='h2-mangeo-sec'>PREMIUM EXPORT QUALITY BANANA</h2>
          <div className='row mango-main'>

            {/* Left Column */}
            <div className='col-md-6 col-sm-12 left-column'>
              <div className='top-row d-flex'>
                <div className='half-img'>
                  <img src='/img/banana-1.png' alt='Mango 1' />
                </div>
                <div className='half-img'>
                  <img src='/img/banana-2.png' alt='Mango 2' />
                </div>
              </div>
              <div className='top-row d-flex'>
                <div className='half-img'>
                  <img src='/img/banana-3.png' alt='Mango 1' />
                </div>
                <div className='half-img'>
                  <img src='/img/banana-4.png' alt='Mango 2' />
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className='col-md-6 col-sm-12 right-column d-flex flex-column'>
              <div className='top-full-img'>
                <img src='/img/banana-5.png' alt='Fresh Mango' />
              </div>

            </div>

          </div>

          <div className='text-block'>
            <p className='lead'>Bananas are more than just a sweet snack — they’re rich in potassium, vitamin C, and B6, helping support heart health, brain function, and immunity. Easy to digest and energy-boosting, they’re a favorite among athletes. Originally from Southeast Asia, bananas have become one of the world’s most popular fruits, with a history deeply rooted in global trade.
            </p>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>

      </section>
      {/* Page 9 =>  garlic & gignger*/}
      <section class="vegetable-section py-5">

        <div class="container1 container2">
          <h2 className='h2-mangeo-sec'>Fresh Garlic & Ginger Collection</h2>
          <div class="row align-items-center mb-5 flex-column flex-md-row" style={{ marginTop: '20px' }}>
            <div class="col-md-7 order-md-1">
              <h3 class="mb-3">Fresh Garlic</h3>
              <p className='lead'>Garlic is a versatile ingredient widely used in cooking due to its distinctive flavor and aroma. It belongs to the onion family and is known for its health benefits, including boosting the immune system and having antioxidant properties. In Culinary applications, garlic can be used in various forms such as raw, minced, sliced or roasted, adding depth and complexity to dishes ranging from pasta sauces to soups and marinades.</p>
            </div>
            <div class="col-md-5 order-1 order-md-2 text-center">
              <img src="/img/garlic.png" alt="Garlic" class="img-fluid rounded shadow-sm" />
            </div>
          </div>


          <div class="row align-items-center flex-column flex-md-row">

            <div class="col-md-7">
              <h3 class="mb-3">Premium Ginger</h3>
              <p className='lead'>"Ginger" can refer to a few different things! It could be the root of the ginger plant, often used in cooking and for its medicinal properties. It's also a popular flavoring in various cuisines, adding a spicy, slightly sweet taste. Ginger can also refer to a person with red hair, which is where the term "ginger" as a nickname comes from.</p>
            </div>
            <div class="col-md-5 text-center">
              <img src="/img/ginger.png" alt="Ginger" class="img-fluid rounded shadow-sm" />
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 10 =>  Fruits 6 img*/}

      <section class="fruits-6 py-5">
        <div class="container1 container2">
          <div class="row g-4">

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/pomegranate.png" alt="pomegranate" class="img-fluid rounded" />
                <div class="fruit-name">Pomegranate</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/apple.png" alt="apple" class="img-fluid rounded" />
                <div class="fruit-name">Apple</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/guava.png" alt="guava" class="img-fluid rounded" />
                <div class="fruit-name">Guava</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/mix-fruits-card.jpg" alt="mix-vegetable" class="img-fluid rounded" />
                <div class="fruit-name">Mix-Vegitables</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/lemon.png" alt="lemon" class="img-fluid rounded" />
                <div class="fruit-name">Lemon</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/onion.png" alt="onion" class="img-fluid rounded" />
                <div class="fruit-name">Onion</div>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>

      {/* Page 11 =>  dates*/}

      <section className='frozen-food-sec'>
        <div className='container'>
          <h2 className='potatos'>PREMIUM EXPORT QUALITY DATES</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-2 order-md-1">
              <div className="img-box2 order-md-1">
                <img src="/img/dates1.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
              <div className="frozen-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1.12rem' }}>Embark on a journey of flavor and tradition with our exquisite Pakistani dates, sourced from the sundrenched groves of the Indus Valley. Renowned for their rich sweetness and exceptional quality, our dates are meticulously harvested and carefully processed to preserve their natural goodness and distinct taste.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1 order-md-3">
                <img src="/img/dates2.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 12 =>  dry fruits*/}

      <section class="fruits-6 py-5">
        <div class="container1 container2">
          <div class="row g-4">
            <h2 className='lead'>PREMIUM EXPORT QUALITY DRY FRUITS</h2>
            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/almonds.png" alt="almonds" class="img-fluid rounded" />
                <div class="fruit-name">Almonds</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/cashewsnuts.png" alt="Cashews Nuts" class="img-fluid rounded" />
                <div class="fruit-name">Cashews Nuts</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/walnuts.png" alt="Walnuts" class="img-fluid rounded" />
                <div class="fruit-name">Walnuts</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/pista.png" alt="Pistachios Nuts" class="img-fluid rounded" />
                <div class="fruit-name">MPistachios Nuts</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/raisins.png" alt="Rasins" class="img-fluid rounded" />
                <div class="fruit-name">Rasins</div>
              </div>
            </div>

            <div class="col-12 col-sm-6 col-md-4">
              <div class="fruit-card position-relative">
                <img src="/img/anjeer.png" alt="Anjeer" class="img-fluid rounded" />
                <div class="fruit-name">Anjeer</div>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 13 =>  rise*/}

      <section className='mango-layout'>
        <div className='container1'>
          <h2 className='h2-mangeo-sec'>PREMIUM EXPORT QUALITY RICE</h2>
          <div className='row mango-main'>

            {/* Left Column */}
            <div className='col-md-6 col-sm-12 left-column'>
              <div className='top-row d-flex'>
                <div className='half-img'>
                  <img src='/img/rise1.png' alt='Mango 1' />
                </div>
                <div className='half-img'>
                  <img src='/img/ahh-rice-bag.png' alt='Mango 2' />
                </div>
              </div>
              <div className='bottom-row'>
                <div className='text-block'>
                  <p className='lead' style={{ fontSize: '1.05rem' }} >"Experience the essence of Pakistan's agricultural excellence with our premium rice varieties, meticulously cultivated in the fertile fields of the Indus Valley. Renowned for their aromatic fragrance and exquisite flavor, our rice varieties are a testament to Pakistan's rich culinary heritage.We export and deal with different types of rice, such as:"Basmati, IRRI, R, Cold Tolerant," etc."
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className='col-md-6 col-sm-12 right-column d-flex flex-column '>
              <div className='top-full-img'>
                <img src='/img/rise3.png' alt='Fresh Mango' />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 14 =>  pluses*/}

      <section className='mango-layout'>
        <div className='container1'>
          <h2 className='h2-mangeo-sec'>PREMIUM EXPORT QUALITY PLUSES</h2>
          <div className='row mango-main'>

            {/* Left Column */}
            <div className='col-md-6 col-sm-12 left-column'>
              <div className='top-row d-flex'>
                <div className='half-img'>
                  <img src='/img/pulses1.png' alt='Mango 1' />
                </div>
                <div className='half-img'>
                  <img src='/img/pulses2.png' alt='Mango 2' />
                </div>
              </div>
              <div className='bottom-row'>
                <div className='text-block'>
                  <p className='lead' style={{ fontSize: '1.05rem' }} >Discover the richness of Pakistan’s agricultural heritage with our premium quality pulses, cultivated in the fertile soils of Punjab and Sindh. Known for their exceptional taste and nutritional value, our pulses are a staple in kitchens around the world.We export and supply a wide variety of pulses, including:Moong, Mash, Masoor, and Chana, among others.
                  </p>
                </div>
              </div>
            </div>

            {/* Right Column */}
            <div className='col-md-6 col-sm-12 right-column d-flex flex-column '>
              <div className='top-full-img'>
                <img src='/img/pulses3.png' alt='Fresh Mango' />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 15 =>  bed sheets*/}

      <section className='fries-section'>
        <div className='container1'>
          <h2>PREMIUM EXPORT QUALITY BEED SHEETS</h2>

          <div className="fries-row row">
            {/* Left Column: Text + Top Image */}
            <div className="col-md-6 col-sm-12 fries-left-col d-flex flex-column order-2 order-md-1">
              <div className="fries-single-img-box order-md-1">
                <img src="/img/bedsheet1.png" alt="Frozen Pack" className="fries-single-img w-100" />
              </div>
              <div className="fries-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1.12rem' }}>
                A bed sheet is the first layer of comfort placed over a mattress, providing a soft and smooth sleeping surface. Typically made from cotton, linen, or other high-quality fabrics, our bed sheets come in a range of sizes, colors, and patterns to match any bedding style.
                Not only do they enhance comfort, but they also protect the mattress and add a touch of elegance to your bedroom.
                </p>
              </div>
            </div>

            {/* Right Column: 4-image Grid */}
            <div className="col-md-6 col-sm-12 fries-right-col order-1 order-md-2">
              <div className="fries-grid d-flex flex-wrap gap-2">
                <div className="fries-grid-img-box w-50">
                  <img src="/img/bedsheet2.png" alt="Potato A" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/bedsheet3.png" alt="Potato B" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/bedsheet4.png" alt="Potato C" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
                <div className="fries-grid-img-box w-50">
                  <img src="/img/bedsheet5.png" alt="Potato D" className="fries-grid-img w-100 h-100 object-fit-cover" />
                </div>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>

      {/* Page 16 =>  Chicken*/}

      <section className='frozen-food-sec'>
        <div className='container'>
          <h2>PREMIUM QUALITY CHICKEN, BEEF , LAMB , MUTTON</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-1 order-md-1">
              <div className="img-box3 order-md-1">
                <img src="/img/chicken-1.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
              <div className="img-box3 order-md-1 ">
                <img src="/img/chicken-2.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box3 order-md-1 box-3">
                <img src="/img/chicken-3.png" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
              <div className="frozen-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1rem' }}>AHH INTERNATIONAL IMPORT & EXPORT GROUP is a trusted exporter of premium quality chicken, beef, lamb, mutton. Using advanced technology and strict HACCP and ISO standards, we ensure top-tier hygiene, nutrition, and taste. Our skilled team manages the entire process — from slaughtering and cutting to packaging, blast freezing.
                </p>
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>

      {/* Page 17 => towel */}

      <section className='frozen-food-sec'>
        <div className='container'>
          <h2>PREMIUM EXPORT QUALITY TOWEL</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div d-flex flex-column order-2 order-md-1">
              <div className="img-box2 order-md-1">
                <img src="/img/towel1.jpg" alt="Frozen Pack" className="frozen-img w-100" />
              </div>
              <div className="frozen-text-box p-4 order-md-2">
                <p className='lead' style={{ fontSize: '1.12rem' }}>
                  A towel is a versatile and practical item, perfect for drying off after a bath, shower, or swim. Made from highly absorbent materials like cotton, towels come in various types and sizes—including bath towels, hand towels, and beach towels—to suit every need. Beyond personal care, they’re great for household use too—cleaning spills, protecting surfaces.
                </p>
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1 order-md-3">
                <img src="/img/towel2.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>
          <div className="text-center mb-4">
            <Link to="/contact" className="btn btn-contact lead">
              Let's Connect
            </Link>
          </div>
        </div>
      </section>
      {/* Page 18 =>  EXPORT & IMPORT WITH MULTIPLE COUNTRIES*/}

      <section className='frozen-food-sec'>
        <div className='container'>
          <h2>EXPORT & IMPORT WITH MULTIPLE COUNTRIES</h2>

          <div className="frozen-div row">
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2">
              <div className="img-box1 order-1 order-md-3">
                <img src="/img/import1.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
            <div className="col-md-6 col-sm-12 parent-frozen-div order-1 order-md-2 mt-4">
              <div className="img-box1 order-1 order-md-3">
                <img src="/img/import2.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
              </div>
            </div>
          </div>
          
        </div>
      </section>
      {/* Page 19 => working with */}
      <section className='working-img'>
        <div className='container-working'>
          <h2>WORKING WITH</h2>

          <div className="frozen-div  row mt-4">
            <div className="col-md-11 col-sm-11 parent-frozen-div ">
              <img src="/img/working.png" alt="Main Frozen" className="frozen-img w-100 h-100" />
            </div>
          </div>
        </div>
      </section>
      {/* Page 20 => working with by airlines*/}
      <section className='working-img-sec'>
        <div className='container-working'>
          <h2>WORKING WITH BY AIRLINES</h2>
          <div className="frozen-div-working  row mt-4">
            <div className="col-md-11 col-sm-11 parent-frozen-div ">
              <img src="/img/working-airline.png" alt="Main Frozen" className="frozen-img " />
            </div>
          </div>
        </div>
      </section>
      {/* Page 21 => working with sea */}
      <section className='working-img-sec'>
        <div className='container-working'>
          <h2>WORKING WITH BY SEA</h2>
          <div className="frozen-div-working  row mt-4">
            <div className="col-md-11  col-sm-11 parent-frozen-div ">
              <img src="/img/working-sea.png" alt="Main Frozen" className="frozen-img " />
            </div>
          </div>
        </div>
      </section>

      <div className="catalogue-section text-center">
  <h2 className="catalogue-heading">📘 Our Company Catalogue</h2>
  <p className="catalogue-text">
    Discover our premium range of export products and services! <br />
    Download our official catalogue to explore what AHH International Group has to offer. <br />
    From top-quality fruits and vegetables to dry fruits, meat, and textiles – everything is included!
  </p>
  <a 
    href="/catalogue/AHH-International-Catalogue.pdf" 
    download 
    className="catalogue-btn"
  >
    📥 Download Catalogue
  </a>
</div>

    </>
  )
}

export default Home
